module.exports = __webpack_public_path__ + "img/inge-v6-char-1.a2f3cdc0.png";